import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../../img/logo.png';
import '../../scss/v2/v2-base.scss';
import '../../scss/v2/v2-pages.scss';

const Unauthorized = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.removeAttribute('class');
    document.body.classList.add('unauthorized');
    document.title = 'Немає доступу | New Brain';
  }, []);

  return (
    <main className="nf-page">
      <img className="nf-page__logo" src={Logo} alt="New Brain" width="56" height="64" />
      <h1 className="nf-page__title">Немає доступу</h1>
      <p className="nf-page__text">Ця сторінка недоступна для вашого акаунта. Якщо вважаєте, що це помилка, напишіть нам у Telegram.</p>
      <div className="nf-page__actions">
        <button type="button" className="v2-btn v2-btn--violet" onClick={() => navigate('/')}>На головну кабінету</button>
        <button type="button" className="v2-btn v2-btn--outline" onClick={() => navigate(-1)}>Назад</button>
      </div>
    </main>
  );
};

export default Unauthorized;
